import { Link } from "react-router-dom";
import { Card } from "@/components/ui/Card";
import { DatevSettingsSection } from "./sections/dokumente/DatevSettingsSection";
import { GdLohnartenSection } from "./sections/dokumente/GdLohnartenSection";
import { SettingsAccessDenied } from "./SettingsLayout";
import { useSettingsAcl } from "./lib/useSettingsAcl";

export function DokumenteSettingsPage() {
  const acl = useSettingsAcl();

  if (!acl.loading && !acl.canAuftraege) {
    return <SettingsAccessDenied />;
  }

  return (
    <div className="space-y-4">
      <GdLohnartenSection />
      <DatevSettingsSection />
      <Card
        title="Mahnwesen"
        description="Die Mahnwesen-Einstellungen (Stufen, Texte, Zinsen, Basiszinssätze, Berechtigungen) sind in den Mahnwesen-Bereich umgezogen."
      >
        <Link
          to="/dokumente/mahnwesen"
          className="inline-flex items-center rounded-lg border border-separator-opaque px-3 py-2 text-sm font-medium text-label hover:bg-fill-tertiary"
        >
          Zum Mahnwesen (Tab „Einstellungen“)
        </Link>
      </Card>
    </div>
  );
}
